<template>
    <div class="d-flex justify-content-center flex-wrap py-3">
        <form @submit.prevent="signUp" class="col-12 col-sm-4 d-flex flex-wrap bg-white shadow rounded p-5">
            <div class="col-12 text-center mb-4">
                <h3>
                    {{ $t(`Auth.${this.$route.name}.RouteName`) }}
                </h3>
            </div>
            <div class="col-12 mb-2 form-field">
                <label for="name" class="mb-2">
                    <small :class="{'text-danger' : errors.name}">
                        {{ $t('Auth.SignUp.name') }}
                    </small>
                    <span v-if="errors.name" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.name" class="text-danger">
                        {{ errors.name }}
                    </small>
                </label>
                <input v-model="newUser.name" @focus="errors.name = null" name="name" type="text" class="form-control" id="name" :placeholder="$t('Auth.SignUp.insert_name')" :class="{'text-danger border-danger' : errors.name}">
            </div>
            <div class="col-12 mb-4 form-field">
                <label for="nsurnameame" class="mb-2">
                    <small :class="{'text-danger' : errors.surname}">
                        {{ $t('Auth.SignUp.surname') }}
                    </small>
                    <span v-if="errors.surname" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.surname" class="text-danger">
                        {{ errors.surname }}
                    </small>
                </label>
                <input v-model="newUser.surname" @focus="errors.surname = null" name="surname" type="text" class="form-control" id="surname" :placeholder="$t('Auth.SignUp.insert_surname')" :class="{'text-danger border-danger' : errors.surname}">
            </div>
            <div class="col-12 mb-2 form-field">
                <label for="email" class="mb-2">
                    <small :class="{'text-danger' : errors.email}">
                        {{ $t('Auth.SignUp.email') }}
                    </small>
                    <span v-if="errors.email" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.email" class="text-danger">
                        {{ errors.email }}
                    </small>
                </label>
                <input v-model="newUser.email" @focus="errors.email = null" name="email" type="email" class="form-control" id="email" :placeholder="$t('Auth.SignUp.insert_email')" :class="{'text-danger border-danger' : errors.email}">
            </div>
            <div class="col-12 mb-4 form-field">
                <label for="confirm_email" class="mb-2">
                    <small :class="{'text-danger' : errors.confirm_email}">
                        {{ $t('Auth.SignUp.confirm_email') }}
                    </small>
                    <span v-if="errors.confirm_email" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.confirm_email" class="text-danger">
                        {{ errors.confirm_email }}
                    </small>
                </label>
                <input v-model="newUser.confirm_email" @focus="errors.confirm_email = null" name="confirm_email" type="email" class="form-control" id="confirm_email" :placeholder="$t('Auth.SignUp.insert_confirm_email')" :class="{'text-danger border-danger' : errors.confirm_email}">
            </div>
            <div class="col-12 mb-2 form-field">
                <label for="password" class="mb-2">
                    <small :class="{'text-danger' : errors.password}">
                        {{ $t('Auth.SignUp.password') }}
                    </small>
                    <span v-if="errors.password" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.password" class="text-danger">
                        {{ errors.password }}
                    </small>
                </label>
                <div class="position-relative">
                    <input v-model="newUser.password" @focus="errors.password = null" name="password" :type="passwordShowed ? 'text' : 'password'" class="form-control" id="password" :placeholder="$t('Auth.SignUp.insert_password')" :class="{'text-danger border-danger' : errors.password}">
                    <i class="position-absolute top-50 end-0 translate-middle fa-regular cursor-pointer" @click="passwordShowed = !passwordShowed" :class="[{'text-danger' : errors.password}, passwordShowed === true ? 'fa-eye' : 'fa-eye-slash']"></i>
                </div>
            </div>
            <div class="col-12 mb-4 form-field">
                <label for="confirm_password" class="mb-2">
                    <small :class="{'text-danger' : errors.confirm_password}">
                        {{ $t('Auth.SignUp.confirm_password') }}
                    </small>
                    <span v-if="errors.confirm_password" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.confirm_password" class="text-danger">
                        {{ errors.confirm_password }}
                    </small>
                </label>
                <div class="position-relative">
                    <input v-model="newUser.confirm_password" @focus="errors.confirm_password = null" name="confirm_password" :type="confirmPasswordShowed ? 'text' : 'password'" class="form-control" id="confirm_password" :placeholder="$t('Auth.SignUp.insert_confirm_password')" :class="{'text-danger border-danger' : errors.confirm_password}">
                    <i class="position-absolute top-50 end-0 translate-middle fa-regular cursor-pointer" @click="confirmPasswordShowed = !confirmPasswordShowed" :class="[{'text-danger' : errors.confirm_password}, confirmPasswordShowed === true ? 'fa-eye' : 'fa-eye-slash']"></i>
                </div>
            </div>
            <div class="col-12 mb-4">
                <label for="language">
                    <small :class="{'text-danger' : errors.language}">
                        {{ $t('Auth.SignUp.language') }}
                    </small>
                    <span v-if="errors.language" class="text-danger mx-2">
                        -
                    </span>
                    <small v-if="errors.language" class="text-danger">
                        {{ errors.language }}
                    </small>
                </label>
                <div>
                    <LanguagesSelect id="language" class="text-second" :class="{'text-danger' : errors.language}" @setLanguage="this.errors = {}"/>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-center align-items-center mb-4">
                <label class="switch me-2">
                    <input type="checkbox" v-model="privacy" @change="this.errors.privacy = null"/>
                    <span class="slider round"></span>
                </label>
                <a href="https://autoguidovie.it/it/c/note-legali/index" target="_blank" class="text-underline" :class="{'text-danger' : errors.privacy}">
                    {{ $t('Auth.SignUp.privacy') }}
                </a>
                <span v-if="errors.privacy" class="text-danger mx-2">
                    -
                </span>
                <small v-if="errors.privacy" class="text-danger">
                    {{ errors.privacy }}
                </small>
            </div>
            <div class="col-12 mb-2">
                <button type="submit" class="btn btn-auth btn-auth-second w-100">
                    {{ $t('Auth.SignUp.sign_up') }}
                </button>
            </div>
            <div class="col-12">
                <router-link to="/" class="btn btn-auth btn-auth-white w-100">
                    {{ $t('Auth.SignUp.go_back') }}
                </router-link>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LanguagesSelect from '@/components/LanguagesSelect.vue'
export default {
    name: 'SignUp',
    components: {
        LanguagesSelect
    },
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey']),
    },
    data() {
        return {
            newUser: {
                name: null,
                surname: null,
                date_of_birth: null,
                email: null,
                confirm_email: null,
                password: null,
                confirm_password: null,
                language: this.$i18n.locale,
            },
            passwordShowed: false,
            confirmPasswordShowed: false,
            privacy: false,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        signUp() {
            this.errors = {}
            if (this.privacy === false) {
                this.errors.privacy = this.$t('Auth.SignUp.errors.privacy.required')
                this.$toast.error(this.$t('toast.fields_errors'))
                return
            }
            this.$http
                .post(`${this.apiPath}/sign_up`, { user: this.newUser }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'user.name') {
                                this.errors.name = this.$t(`Auth.SignUp.errors.name.${error.msg}`)
                            }
                            if (error.path == 'user.surname') {
                                this.errors.surname = this.$t(`Auth.SignUp.errors.surname.${error.msg}`)
                            }
                            if (error.path == 'user.email') {
                                this.errors.email = this.$t(`Auth.SignUp.errors.email.${error.msg}`)
                            }
                            if (error.path == 'user.confirm_email') {
                                this.errors.confirm_email = this.$t(`Auth.SignUp.errors.confirm_email.${error.msg}`)
                            }
                            if (error.path == 'user.password') {
                                this.errors.password = this.$t(`Auth.SignUp.errors.password.${error.msg}`)
                            }
                            if (error.path == 'user.confirm_password') {
                                this.errors.confirm_password = this.$t(`Auth.SignUp.errors.confirm_password.${error.msg}`)
                            }
                            if (error.path == 'user.language') {
                                this.errors.language = this.$t(`Auth.SignUp.errors.language.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                    } else {
                        switch (res.data) {
                            case 'Account Already Exists':
                                this.errors.email = this.$t('Auth.SignUp.errors.email.AccountAlreadyExists')
                                this.$toast.error(this.$t('Auth.SignUp.errors.email.AccountAlreadyExists'))
                                break
                            case 'Account Registered Successfully':
                                this.$http
                                    .post(`${this.apiPath}/email/send_email_confirmation_request`, { email: this.newUser.email }, {
                                        headers: {
                                            'x-api-key': this.omsApiKey
                                        }
                                    }).then((res) => {
                                        this.$toast.success(`<h4>${this.$t('toast.signup_succeeded')}</h4> ${this.$t('toast.sent_email')} <strong>${res.data.data.to}</strong> <h6>${this.$t('toast.confirm_email')}</h6>`)
                                        this.$router.replace('/')
                                    })
                                    .catch((err) => {
                                        this.setErrorFromServer(err.message)
                                    })
                                break
                        }
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    }
}
</script>